// removed by extract-text-webpack-plugin
module.exports = {"overlay":"Overlay_overlay_2ih","fullscreen":"Overlay_fullscreen_emF"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/ui/Overlay/Overlay.css
 ** module id = 577
 ** module chunks = 0
 **/